/**
 * About FAQ accordion section (`.question-card`).
 *
 * Click toggles the card open/closed (Webflow IX2 a-36 open / a-37 close):
 * `.answer-holder` height 0 ↔ auto and the `.drop-down` arrow rotates 0 ↔ 180,
 * both 700ms power1.inOut. Each card toggles independently. The card fade-up on
 * scroll-in is class-driven (handled globally by SiteAnimations).
 */
import type { FC } from 'react'

import { useEffect, useRef } from 'react'

import { gsap } from '@/lib/gsap'

const QUESTIONS: Array<{ question: string; answer: string }> = [
    {
        question: 'Lorem ipsum dolor sit amet?',
        answer: 'Quisque rutrum. Aenean imperdi. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget.'
    },
    {
        question: 'Lorem ipsum dolor sit amet?',
        answer: 'Quisque rutrum. Aenean imperdi. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget.'
    },
    {
        question: 'Lorem ipsum dolor sit amet?',
        answer: 'Quisque rutrum. Aenean imperdi. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget.'
    },
    {
        question: 'Lorem ipsum dolor sit amet?',
        answer: 'Quisque rutrum. Aenean imperdi. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget.'
    },
    {
        question: 'Lorem ipsum dolor sit amet?',
        answer: 'Quisque rutrum. Aenean imperdi. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget.'
    }
]

interface QuestionCardProps {
    question: string
    answer: string
}

const QuestionCard: FC<QuestionCardProps> = ({ question, answer }) => {
    const answerRef = useRef<HTMLDivElement>(null)
    const arrowRef = useRef<HTMLImageElement>(null)
    const open = useRef(false)

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.set(answerRef.current, { height: 0, overflow: 'hidden' })
        })

        return () => ctx.revert()
    }, [])

    const toggle = () => {
        open.current = !open.current

        gsap.to(answerRef.current, {
            height: open.current ? 'auto' : 0,
            duration: 0.7,
            ease: 'power1.inOut'
        })
        gsap.to(arrowRef.current, {
            rotation: open.current ? 180 : 0,
            duration: 0.7,
            ease: 'power1.inOut'
        })
    }

    return (
        <div className='question-card' onClick={toggle}>
            <div className='question-header-container'>
                <p className='no-margins'>{question}</p>
                <div className='question-dropdown-holder'>
                    <img ref={arrowRef} src='/images/Dropdown.svg' loading='lazy' alt='' className='drop-down' />
                </div>
            </div>
            <div ref={answerRef} className='answer-holder'>
                <p className='paragraph-m answer'>{answer}</p>
            </div>
        </div>
    )
}

export const Faq: FC = () => {
    return (
        <div className='section'>
            <div className='container _6ems'>
                <div className='w-layout-grid grid-8-col'>
                    <div id='w-node-_3abd6cd9-c469-465c-f261-970e527a8d55-a854ba1a' className='content'>
                        <div className='sticky-text-container'>
                            <div className='fade-in-move-on-scroll'>
                                <h3>Frequently asked questions about us</h3>
                            </div>
                        </div>
                    </div>
                    <div id='w-node-_3abd6cd9-c469-465c-f261-970e527a8d59-a854ba1a' className='faq-cards-container'>
                        {QUESTIONS.map((item, index) => (
                            <QuestionCard key={index} question={item.question} answer={item.answer} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
